import enCommon from "@/i18n/locales/en/common.json" with { type: "json" };

const routeLoadingLabel = enCommon["app.loading"] ?? "Loading…";

export function RouteLoadingState() {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="tw:rounded-xl tw:border tw:border-iron-800 tw:bg-iron-900 tw:p-4 tw:text-sm tw:text-iron-200"
    >
      {routeLoadingLabel}
    </div>
  );
}
